import React from 'react'
import { StyleSheet } from 'react-native'

import { CTN, Stack, XStack, colors } from '@zet/design-system'

type ProgressBarProps = {
  widthPercentage: number
  isCompleted?: boolean
}

const ProgressBarWithPercentage = ({
  widthPercentage,
  isCompleted,
}: ProgressBarProps) => {
  const backgroundColor = isCompleted
    ? colors.success[100]
    : colors.primary[100]

  return (
    <XStack className="j mt-1 items-center">
      <XStack
        className="bg-grays-45 h-1.5 w-full flex-row items-center"
        style={styles.progressBar}
      >
        <Stack
          className="h-1.5"
          style={{
            width: `${widthPercentage}%`,
            backgroundColor: backgroundColor,
            borderTopLeftRadius: 10,
            borderBottomLeftRadius: 10,
          }}
        />
      </XStack>
      <CTN className="pl-2 text-xs">{widthPercentage}%</CTN>
    </XStack>
  )
}

const styles = StyleSheet.create({
  progressBar: {
    marginHorizontal: -1,
    zIndex: -1,
    maxWidth: '85%',
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
  },
})

export { ProgressBarWithPercentage }
